import { useTranslation } from "react-i18next";
import { styled, type SxProps, type Theme } from "~/common/mui";
import { Alert } from "~/common/mui/Alert/Alert";

const PmaMessageAlert = styled(Alert, {
  shouldForwardProp: (prop) => prop !== "hasClick" && prop !== "short",
})<{ hasClick: boolean; short?: boolean }>(({ theme, hasClick, short }) => ({
  ...(hasClick && {
    cursor: "pointer",
    ...(short && {
      "& span": {
        textDecoration: "underline",
      },
    }),
  }),
  "& .scha__message__icon": {
    alignSelf: "initial",
  },
}));

interface InfoProductMessagePMAProps {
  short?: boolean;
  onClick?: () => void;
  className?: string;
  sx?: SxProps<Theme>;
}

export const InfoProductMessagePMA = ({ short, onClick, className, sx }: InfoProductMessagePMAProps) => {
  const { t } = useTranslation();
  return (
    <PmaMessageAlert severity={"info"} onClick={onClick} className={className} sx={sx} hasClick={!!onClick} short={short}>
      {t(`product.pma.messages.${short ? "short" : "long"}`)}
    </PmaMessageAlert>
  );
};
